import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["value"]

import { ref, computed, watch } from "vue";
import {
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  RadioItem,
  InputField,
  SelectItem,
  ButtonContainer,
  ButtonItem,
} from "@/components/modules";
import { withDefaults } from "vue";
import { GeoMap } from "@/geoMap/GeoMap";
import { ICommonView } from "../common/ICommonView";

interface Props {
  geoMap: GeoMap;
  commonView: ICommonView;
  isOpen: boolean;
}
enum measurementModeList {
  /**
   * 距離
   */
  distance = "distance",
  /**
   * 面積
   */
  area = "area",
}

/**
 * 計測モード
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'calc-area',
  props: {
    geoMap: {},
    commonView: {},
    isOpen: { type: Boolean }
  },
  emits: ["endCalcArea"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 計測モードリスト
 */
const measurementMode = ref(measurementModeList.distance);

/**
 * 計測結果
 */
const measuredValue = ref(0);

/**
 * 距離単位リスト
 */
const DISTANCE_UNIT_LIST = [
  { name: "m", ratio: 1, digit: 0, index: 0 },
  { name: "km", ratio: 1 / 1000, digit: 3, index: 1 },
];

/**
 * 面積単位リスト
 */
const AREA_UNIT_LIST = [
  { name: "㎡", ratio: 1, digit: 0, index: 0 },
  { name: "㎢", ratio: 1 / (1000 * 1000), digit: 3, index: 1 },
];

/**
 * 単位リスト
 */
const unitList = ref(DISTANCE_UNIT_LIST);

/**
 * 単位
 */
const unit = ref(null);

/**
 * 画面開閉時処理
 */
watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      switch (measurementMode.value) {
        case measurementModeList.distance:
          switchDistanceCalc(true);
          break;
        case measurementModeList.area:
          switchAreaCalc(true);
          break;
      }
    } else {
      switch (measurementMode.value) {
        case measurementModeList.distance:
          switchDistanceCalc(false);
          break;
        case measurementModeList.area:
          switchAreaCalc(false);
          break;
      }
      emit("endCalcArea");
    }
  }
);

/**
 * 表示用計測値
 */
const displayMeasuredValue = computed(() => {
  const value = measuredValue.value * unit?.value?.ratio;
  return value ? value.toFixed(unit?.value?.digit) : "";
});

/**
 * 計測モード変更・終了
 */
const changemeasurementMode = (mode: measurementModeList) => {
  switch (mode) {
    case measurementModeList.distance:
      switchAreaCalc(false);
      switchDistanceCalc(true);
      break;
    case measurementModeList.area:
      switchDistanceCalc(false);
      switchAreaCalc(true);
      break;
  }
  measurementMode.value = mode;
};

/**
 * 距離計測開始/終了
 */
const switchDistanceCalc = (isStart: boolean) => {
  if (isStart) {
    props.geoMap.startCalcDistance((distance: number) => {
      measuredValue.value = distance;
    });
    unitList.value = DISTANCE_UNIT_LIST;
    unit.value = unit?.value
      ? DISTANCE_UNIT_LIST[unit.value.index]
      : DISTANCE_UNIT_LIST[1];
  } else {
    props.geoMap.endCalcDistance();
    measuredValue.value = 0;
  }
};

/**
 * 面積計測開始/終了
 */
const switchAreaCalc = (isStart: boolean) => {
  if (isStart) {
    props.geoMap.startCalcArea((area: number) => {
      measuredValue.value = area;
    });
    unitList.value = AREA_UNIT_LIST;
    unit.value = AREA_UNIT_LIST[unit.value.index];
  } else {
    props.geoMap.endCalcArea();
    measuredValue.value = 0;
  }
};

/**
 * 単位更新
 */
const updateUnit = (value: string) => {
  unit.value = unitList.value.find((ele) => {
    return ele.name === value;
  });
};

/**
 * 計測値クリア
 */
const clear = () => {
  measuredValue.value = 0;
  switch (measurementMode.value) {
    case measurementModeList.distance:
      props.geoMap.clearCalcDistance();
      break;
    case measurementModeList.area:
      props.geoMap.clearCalcArea();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "距離",
                  name: "measurementMode",
                  value: measurementModeList.distance,
                  checked: measurementMode.value == measurementModeList.distance,
                  onUpdate: changemeasurementMode
                }, null, 8, ["value", "checked"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "面積",
                  name: "measurementMode",
                  value: measurementModeList.area,
                  checked: measurementMode.value == measurementModeList.area,
                  onUpdate: changemeasurementMode
                }, null, 8, ["value", "checked"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), { column: ['36px', '160px', '50px'] }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createTextVNode("合計")
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: displayMeasuredValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayMeasuredValue).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectItem), {
                  value: unit.value?.name,
                  onUpdate: updateUnit
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitList.value, (ele) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: ele.name,
                        key: ele.index
                      }, _toDisplayString(ele.name), 9, _hoisted_1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonContainer), { align: "right" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ButtonItem), {
          onClick: clear,
          negative: true
        }, {
          default: _withCtx(() => [
            _createTextVNode("クリア")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})